import { Injectable } from "@angular/core";
import { FormGroup } from "@angular/forms";
import { MatDialog } from "@angular/material/dialog";
import { CanDeactivate, Router } from "@angular/router";
import { map, Observable, of } from "rxjs";
import { UnsavedChangesModal } from "../components/core/modal/unsaved-changes-modal/unsaved-changes-modal.component";
import { StorageService } from "../services/storage.service";

export interface UnsavedChangesGuarder {
  formGroup: FormGroup;
  saveAndContinue: (isUserLocked: boolean) => void;
}

@Injectable()
export class CanDeactivateGuard
  implements CanDeactivate<UnsavedChangesGuarder>
{
  constructor(
    private dialog: MatDialog,
    private storageService: StorageService
  ) {}

  canDeactivate(
    component: UnsavedChangesGuarder
  ): Observable<boolean> | Promise<boolean> | boolean {
    if (!component) {
      return true;
    }

    const isUserLocked = this.storageService.isUserLocked();
    if (component?.formGroup?.dirty) {
      if (isUserLocked) {
        component.saveAndContinue(isUserLocked);
        return true;
      } else {
        component?.formGroup?.markAllAsTouched();
        const dialogRef = this.dialog.open(UnsavedChangesModal, {
          data: {
            saveAndContinueAction: component.saveAndContinue.bind(component),
            form: component.formGroup,
          },
        });
        return dialogRef.afterClosed().pipe(map((result) => result));
      }
    }
    return of(true);
  }
}
